import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent } from 'vue-demi';
interface Props {
  icon: keyof typeof components;
  containerSize?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbIcon',
  props: {
    icon: null,
    containerSize: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { icon: keyof typeof components, containerSize: boolean };

const components = {
  download: defineAsyncComponent(
    () => import('../../icons/UiIconDownload.vue')
  ),
  pdfFile: defineAsyncComponent(() => import('../../icons/UiIconPdfFile.vue')),
  tel: defineAsyncComponent(() => import('../../icons/UiIconTel.vue')),
  email: defineAsyncComponent(() => import('../../icons/UiIconEmail.vue')),
  plus: defineAsyncComponent(() => import('../../icons/UiIconPlus.vue')),
  minus: defineAsyncComponent(() => import('../../icons/UiIconMinus.vue')),
  arrowRight: defineAsyncComponent(
    () => import('../../icons/UiIconArrowRight.vue')
  ),
  sliderArrowLeft: defineAsyncComponent(
    () => import('../../icons/UiIconSliderArrowLeft.vue')
  ),
  sliderArrowRight: defineAsyncComponent(
    () => import('../../icons/UiIconSliderArrowRight.vue')
  ),
  quote: defineAsyncComponent(() => import('../../icons/UiIconQuote.vue')),
  arrowLeftBig: defineAsyncComponent(
    () => import('../../icons/UiIconArrowLeftBig.vue')
  ),
  arrowRightBig: defineAsyncComponent(
    () => import('../../icons/UiIconArrowRightBig.vue')
  ),
  chevronRight: defineAsyncComponent(
    () => import('../../icons/UiIconChevronRight.vue')
  ),
  chevronLeft: defineAsyncComponent(
    () => import('../../icons/UiIconChevronLeft.vue')
  ),
  check: defineAsyncComponent(() => import('../../icons/UiIconCheck.vue')),
  'done-in-circle': defineAsyncComponent(
    () => import('../../icons/UiIconDoneInCircle.vue')
  ),
  'info-mark': defineAsyncComponent(
    () => import('../../icons/UiIconInfoMark.vue')
  ),
  ic: defineAsyncComponent(() => import('../../icons/UiIconIc.vue')),
  play: defineAsyncComponent(() => import('../../icons/UiIconPlay.vue')),
};



const icon = computed(() => components[props.icon]);

return { __sfc: true,components, props, icon }
}

})